import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import { ProductResource } from '@df/catalog/product/product.resource';
import { Status } from '@df/core/status';
import { DfModalService } from '@df/ui/modal/df-modal.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsContent } from '@icms/core/content';
import { IconButtonComponent } from '../buttons/icon-button/icon-button.component';
import { NShopThisLook } from './shop-this-look.interface';

@Component({
    selector: 'shop-this-look',
    templateUrl: './shop-this-look.html',
    styleUrls: ['./shop-this-look.scss'],
    standalone: true,
    imports: [NgClass, TranslationModule, IconButtonComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShopThisLookComponent extends UiComponent {
    @ICmsContent({
        watchDepth: 0
    })
    @Input({ required: true })
    content!: NShopThisLook.IData;

    // For true 20px from edge, for false 8px from edge
    @Input()
    bigSpace: boolean = false;

    protected trayStatus = new Status();
    protected products: Product<IProductDataV2>[] = [];
    private productResource = inject(ProductResource);
    private dfModalService = inject(DfModalService);

    override detectChanges(): void {
        if (!this.products?.length && this.content.shopThisLookProducts?.length) {
            this.productResource.loadAllIds(this.content.shopThisLookProducts, 2, { safe: true }).then(products => {
                this.products = products.filter(p => !!p?.data) as Product<IProductDataV2>[];
                this.changeDetectorRef.detectChanges();
            });
        }
        if (!this.products?.length && this.content.shopThisLookProductsSkus?.length) {
            this.productResource.find({ filter: { sku: { $in: this.content.shopThisLookProductsSkus } }, verbosity: 2 }).then(products => {
                this.products = products.filter(p => !!p?.data) as Product<IProductDataV2>[];
                this.changeDetectorRef.detectChanges();
            });
        }
        super.detectChanges();
    }

    async openTray() {
        const products = this.products?.map(p => p.id);
        if (!!products) {
            this.trayStatus.busy = true;
            this.detectChanges();
            // if we need load on click but in that case we arent able to check if provided ids and skus are valid
            // const trayProducts = (await this.productResource.loadAllIds(products, 2, {safe :true}))?.filter(
            //     p => !!p?.data
            // ) as Product<IProductDataV2>[];
            if (this.products?.length) {
                this.dfModalService.open(undefined, NShopThisLook.MODAL_ID, undefined, {
                    products: this.products,
                    title: 'Shop this look'
                } as NShopThisLook.IModalData);
            }
            this.trayStatus.busy = false;
        }
    }
}
